import { RecordPaymentRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateRecordPayment = makeValidator({
  FieldParser: RecordPaymentRow,
});
